var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20397_6050)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20397_6050",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 5,
    width: 25,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6816 16.3755C23.6816 18.3085 22.1146 19.8755 20.1816 19.8755C18.2486 19.8755 16.6816 18.3085 16.6816 16.3755C16.6816 14.4425 18.2486 12.8755 20.1816 12.8755C22.1146 12.8755 23.6816 14.4425 23.6816 16.3755Z",
    fill: "url(#paint0_linear_20397_6050)",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9C4.5 8.44772 4.94772 8 5.5 8H9.5C10.0523 8 10.5 8.44772 10.5 9C10.5 9.55228 10.0523 10 9.5 10H5.5C4.94772 10 4.5 9.55228 4.5 9Z",
    fill: "url(#paint1_linear_20397_6050)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7189 5C16.3694 5 16.8473 5.61202 16.6896 6.24316L16.5001 7L16.6661 6.83398C16.8856 6.61452 17.1539 6.44972 17.4484 6.35156L18.2364 6.08789C18.3659 6.04472 18.5001 6.14181 18.5001 6.27832V8.72266C18.5001 8.85917 18.3659 8.95625 18.2364 8.91309L17.4484 8.64941C17.1539 8.55126 16.8856 8.38645 16.6661 8.16699L16.5001 8C16.5001 8 16.9515 9.80624 18.0099 10.4141C18.1201 10.4773 18.2452 10.5079 18.3712 10.5244L21.589 10.9453C21.8241 10.9761 22.0001 11.1769 22.0001 11.4141V11.5273C22 11.7881 21.7882 11.999 21.5275 11.999H20.0001C19.722 11.999 19.4395 12.0403 19.1593 12.1162C17.7703 12.4388 16.6283 13.4044 16.0636 14.6826C15.7697 15.2338 15.5968 15.8205 15.5968 16.3906C15.5968 16.5977 15.6135 16.801 15.6456 16.999H8.62626C8.66265 16.7967 8.68164 16.5883 8.68164 16.3755C8.68164 14.4425 7.11464 12.8755 5.18164 12.8755C3.24864 12.8755 1.68164 14.4425 1.68164 16.3755C1.68164 16.5883 1.70063 16.7967 1.73702 16.999H0.98253C0.400718 16.9989 -0.0583105 16.5042 0.00499137 15.9258C0.0695514 15.3359 0.161727 14.652 0.270616 14.2891C0.989868 11.8917 3.30385 9.99905 5.80675 9.99902H9.00011C9.5521 9.99923 9.99992 10.446 10.0001 10.998V13.999C10.0001 14.5513 10.4478 14.999 11.0001 14.999H13.0001C14.1045 14.9988 15.0001 14.1035 15.0001 12.999V6.99902H13.5001C13.224 6.99902 13.0001 6.77514 13.0001 6.49902C13.0002 6.22296 13.224 5.99898 13.5001 5.99902H15.0001V5.40039C15.0002 5.17964 15.1788 5.00022 15.3995 5H15.7189Z",
    fill: "url(#paint2_linear_20397_6050)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73702 16.999C2.03112 18.6345 3.46146 19.8755 5.18164 19.8755C6.90182 19.8755 8.33216 18.6345 8.62626 16.999H1.73702Z",
    fill: "url(#paint3_linear_20397_6050)",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18164 12.8755C3.24864 12.8755 1.68164 14.4425 1.68164 16.3755C1.68164 16.5883 1.70063 16.7967 1.73702 16.999H8.62626C8.66265 16.7967 8.68164 16.5883 8.68164 16.3755C8.68164 14.4425 7.11464 12.8755 5.18164 12.8755Z",
    fill: "url(#paint4_linear_20397_6050)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20397_6050)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F05A5A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20397_6050",
    x1: 8.7741,
    y1: 10.9502,
    x2: 14.862,
    y2: 22.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20397_6050",
    x1: 8.7741,
    y1: 10.9502,
    x2: 14.862,
    y2: 22.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20397_6050",
    x1: 8.7741,
    y1: 10.9502,
    x2: 14.862,
    y2: 22.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20397_6050",
    x1: 8.7741,
    y1: 10.9502,
    x2: 14.862,
    y2: 22.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20397_6050",
    x1: 8.7741,
    y1: 10.9502,
    x2: 14.862,
    y2: 22.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20397_6050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoto);
export default __webpack_public_path__ + "static/media/Moto.28a403536b1e2b0bb5117daf0f368b6c.svg";
export { ForwardRef as ReactComponent };